import { render, staticRenderFns } from "./RobotData.vue?vue&type=template&id=3c25f2a5&"
import script from "./RobotData.vue?vue&type=script&lang=js&"
export * from "./RobotData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports